@if (value()) {
  <app-images-form
    [edit]="true"
    [create]="false"
    [delete]="false"
    [details]="false"
    [access]="access()"
    [value]="value()"
  ></app-images-form>
}
